import http from './http'

export function getProfile() {
  return http.get('/user')
}

export function updateProfile(payload) {
  return http.put('/user', payload)
}

export function resetApiKey() {
  return http.post('/user/reset-api-key')
}
